import { Grid } from '@mui/material'
import CellHOC from '@platform/react/hoc/list/cell'
import { forwardRef } from 'react'
import Chip from 'ui/Element/Text/Chip'
import Text from 'ui/Element/Text'

const styles = () => ({
  option: {
    gap: 12,
  },
  subLabel: {
    gap: 4,
    flexWrap: 'nowrap',
  },
})

/**
 * Displays the name of a documentation.
 *
 * @param {Object} classes  element's style classes
 * @param {Object} props    element's properties
 *
 * @returns {JSX.Element}
 */
export const ListItemCellDashboardDocumentationName = (classes, props = {}) => {
  const { label = '-', product } = props

  const ForwardedChip = forwardRef((chipProps, ref) => <Chip forwardedRef={ref} {...chipProps} />)
  const productLabels = product.map((item, index) => (
    <ForwardedChip
      key={index}
      value={item}
      size={'tiny'}
      color={'pending.700'}
      backgroundColor={'pending.50'}
    />
  ))

  return (
    <Grid
      container
      direction={'row'}
      flexWrap={'nowrap'}
      className={classes.option}
    >
      <Grid
        item
        xs={'auto'}
        sx={{ flexShrink: '1!important' }}
      >
        <Grid
          container
          direction={'column'}
          alignItems={'flex-start'}
          justifyContent={'center'}
        >
          <Text
            maxLines={1}
            value={label}
            variant={'14/bold'}
            color={'black.main'}
          />
          {productLabels?.length ? (
            <Grid
              item
              container
              xs={'auto'}
              className={classes.subLabel}
            >
              {productLabels}
            </Grid>
          ) : null}
        </Grid>
      </Grid>
    </Grid>
  )
}

export default CellHOC(ListItemCellDashboardDocumentationName, styles)
